<nz-spin [nzSpinning]="loading">
    <nz-flex nzGap="small" nzWrap="wrap">
        @if (showLuidaisLink) {
            <button nz-button nz-tooltip nzTooltipTitle="Skatīt LUIDAIS" (click)="gotoLuidaisAbsence()">
                <span nz-icon nzType="link" nzTheme="outline"></span>
            </button>
        }
        <button nz-button nz-tooltip nzTooltipTitle="Paziņojums darbiniekam" (click)="sendAbsenceEmployeeNotification()">
            <span nz-icon nzType="mail" nzTheme="outline"></span>
        </button>
        @if ((hasMenuBookkeeperPermission || userPerformerIds.includes(performerId)) && status == AbsenceStatus.NEW) {
            <button nz-button nz-tooltip nzTooltipTitle="Labot prombūtni" (click)="editAbsence()">
                <i nz-icon nzType="edit"></i>
            </button>
        }
        @if (hasMenuBookkeeperPermission) {
            <button nz-button nzDanger nz-tooltip nzTooltipTitle="Dzēst prombūtni" (click)="deleteAbsence()">
                <i nz-icon nzType="delete"></i>
            </button>
        }
        <cl-notification-history-button [entityType]="EntityType.Absence" [id]="id"></cl-notification-history-button>
    </nz-flex>
</nz-spin>
